import type { TLocalize } from '@hooks/use-localize';

interface IRequiredFieldsAlertProps {
    show: boolean;
    t: TLocalize;
}

const RequiredFieldsAlert = ({ show, t }: IRequiredFieldsAlertProps) => {
    if (!show) return null;

    return (
        <div className="row row-margined">
            <div className="col-xs-12">
                <div className="alert alert-danger alert-sm validation-summary" style={{ margin: 0 }}>
                    {t(
                        'Alert_PleaseCompleteRequiredFields',
                        'Please complete the required fields indicated below',
                    )}
                </div>
            </div>
        </div>
    );
};

export default RequiredFieldsAlert;
